const API_BASE_URL = process.env.REACT_APP_API_URL;

function getAuthHeaders() {
    const token = localStorage.getItem("token");
    return {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
    };
}

export async function getMyProfileApi() {
    const response = await fetch(`${API_BASE_URL}/api/profile/me`, {
        method: "GET",
        headers: getAuthHeaders(),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.message || "No se pudo obtener el perfil");
    }

    return data;
}

export async function updateMyProfileApi(payload) {
    const response = await fetch(`${API_BASE_URL}/api/profile/me`, {
        method: "PUT",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.message || "No se pudo actualizar el perfil");
    }

    return data;
}